// Поколение замка skipSave: таймер снимает блокировку, только если за это время
// не ставили новую. Нужен эффекту WS/poll в App.jsx — старый setTimeout(false)
// после cleanup снимал замок посреди новой загрузки.
// Потолок: непрерывная цепочка блокировок держит замок не дольше maxHoldMs
// от первой блокировки цепочки (монотонные часы, не стена).
// Boot-загрузка держит замок отдельно: конец цепочки не снимает, пока boot
// держит, и наоборот.
const COOLDOWN_MS = 1000;

let lockGen = 0;
let chainStartedAt = null;
let cooldownUntil = null;
let bootHeld = false;
let bootFailed = false;
let lastBootFailedRemindAt = null;
let nowImpl = null;

function monoNow() {
  if (nowImpl) return nowImpl();
  if (typeof performance !== 'undefined' && typeof performance.now === 'function') {
    return performance.now();
  }
  return Date.now();
}

function syncSkipSave(skipSaveRef) {
  skipSaveRef.current = bootHeld || chainStartedAt != null;
}

/**
 * @param {{ current: boolean }} skipSaveRef
 */
export function holdBootSkipSave(skipSaveRef) {
  bootHeld = true;
  bootFailed = false;
  lastBootFailedRemindAt = null;
  syncSkipSave(skipSaveRef);
}

/**
 * @param {{ current: boolean }} skipSaveRef
 */
export function releaseBootSkipSave(skipSaveRef) {
  bootHeld = false;
  syncSkipSave(skipSaveRef);
}

export function isBootSkipSaveHeld() {
  return bootHeld;
}

const BOOT_FAILED_REMIND_MS = 120000;

export function markBootFailed() {
  bootFailed = true;
  lastBootFailedRemindAt = monoNow();
}

export function isBootFailed() {
  return bootFailed;
}

/** true не чаще раза в 120 с по монотонным часам; false, если флаг не выставлен. */
export function shouldRemindBootFailed() {
  if (!bootFailed) return false;
  const now = monoNow();
  if (lastBootFailedRemindAt != null && now - lastBootFailedRemindAt < BOOT_FAILED_REMIND_MS) {
    return false;
  }
  lastBootFailedRemindAt = now;
  return true;
}

/**
 * @param {{ current: boolean }} skipSaveRef
 * @param {number} [delayMs]
 * @param {number} [maxHoldMs]
 * @returns {ReturnType<typeof setTimeout>|undefined}
 */
export function lockSkipSave(skipSaveRef, delayMs = 2000, maxHoldMs = 6000) {
  const now = monoNow();
  if (cooldownUntil != null && now < cooldownUntil) {
    syncSkipSave(skipSaveRef);
    return undefined;
  }
  cooldownUntil = null;

  if (chainStartedAt != null && now - chainStartedAt >= maxHoldMs) {
    chainStartedAt = null;
    cooldownUntil = now + COOLDOWN_MS;
    syncSkipSave(skipSaveRef);
    return undefined;
  }

  if (chainStartedAt == null) {
    chainStartedAt = now;
  }

  const remainingCap = Math.max(0, maxHoldMs - (now - chainStartedAt));
  const wait = Math.min(delayMs, remainingCap);
  const gen = ++lockGen;
  syncSkipSave(skipSaveRef);
  return setTimeout(() => {
    if (gen !== lockGen) return;
    const end = monoNow();
    const started = chainStartedAt;
    chainStartedAt = null;
    if (started != null && end - started >= maxHoldMs) {
      cooldownUntil = end + COOLDOWN_MS;
    }
    syncSkipSave(skipSaveRef);
  }, wait);
}

/** @param {(() => number)|null} [fn] */
export function _setSkipSaveMonoNow(fn) {
  nowImpl = fn || null;
}

export function _resetSkipSaveLockGen() {
  lockGen = 0;
  chainStartedAt = null;
  cooldownUntil = null;
  bootHeld = false;
  bootFailed = false;
  lastBootFailedRemindAt = null;
  nowImpl = null;
}
